<template>
  <div class="w-full h-full overflow-hidden grid grid-cols-[1fr]">
    <div class="overflow-hidden grid grid-rows-[1fr]">
      <VanTabs
        class="w-full overflow-hidden grid grid-rows-[auto_1fr] all-tabs"
        v-model:active="step"
        :ellipsis="false"
        line-width="20"
        line-height="2"
      >
        <!-- 原图 -->
        <VanTab
          v-if="showTabs.includes('origin')"
          name="origin"
          :title="t(`painting.origin.title`)"
        >
          <ImageTabsLayout
            :req-data="reqData"
            is-origin
            @upload-nsfw-image="
              (media) => emit('uploadNsfwImage', { media, type: 'env' })
            "
          />
        </VanTab>

        <!-- 待替换图 -->
        <VanTab
          v-if="showTabs.includes('replace')"
          name="replaces"
          :title="t(`painting.${mode === '10' ? 'origin' : 'replace'}.title`)"
        >
          <ImageTabsReplace
            :req-data="reqData"
            @upload-nsfw-image="
              (media) => emit('uploadNsfwImage', { media, type: 'source' })
            "
          />
        </VanTab>
        <!-- 描述词/全局 -->
        <VanTab
          v-if="showTabs.includes('prompt')"
          name="prompt"
          :title="mode === '3' ? t(`painting.global`) : t(`painting.prompt`)"
          class="after:pt-10"
        >
          <EditPrompts
            :mode="modeMap[mode]"
            v-model:prompt="reqData.prompt"
            v-model:negative-prompt="reqData.negativePrompt"
            :is-unlimited="reqData.isUnlimited"
            :show-negative="!['10'].includes(mode)"
          />
        </VanTab>
        <!-- 人物特征 -->
        <VanTab
          v-if="showTabs.includes('traits')"
          :title="
            mode === '6'
              ? t(`painting.replaceWith.title`)
              : t(`painting.people.feature`)
          "
          name="traits"
        >
          <ImageTabsTraits v-if="mode !== '3'" :req-data="reqData" />
          <ImageTabsTraitMuti1 v-else :req-data="reqData" />
        </VanTab>

        <!-- 参考图 -->
        <VanTab
          v-if="showTabs.includes('layout')"
          name="layout"
          :title="t(`painting.layout.title`)"
        >
          <ImageTabsReferImg
            :req-data="reqData"
            @upload-nsfw-image="
              (media) => emit('uploadNsfwImage', { media, type: 'env' })
            "
          />
        </VanTab>

        <!-- 风格 -->
        <VanTab
          v-if="showTabs.includes('style')"
          name="style"
          :title="t(`painting.style.title`)"
        >
          <ImageTabsStyle
            v-model:imageStyle="reqData.style"
            v-model:mix-style="reqData.mixStyle"
            v-model:custom-style="reqData.customStyle"
          />
        </VanTab>

        <!-- 生成设置 -->
        <VanTab
          v-if="showTabs.includes('setting')"
          name="setting"
          :title="t(`painting.setting`)"
        >
          <ImageTabsSetting :req-data="reqData" />
        </VanTab>
      </VanTabs>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { onMounted } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const { mode } = route.query as any;
const modeMap: any = {
  1: "single",
  2: "single",
  3: "multi",
  4: "nobody",
  10: "faceExpression",
};

const props = defineProps({
  reqData: {
    type: Object as PropType<PromptJson>,
    required: true,
  },
  showTabs: {
    type: Object as PropType<string[]>,
    default: () => ["prompt", "layout", "env", "style", "setting"],
  },
});

const emit = defineEmits(["uploadNsfwImage"]);

const step = ref("");
const { t } = useI18n();

const showMutiMode = ref(true);

onMounted(() => {
  if (props.reqData.isUnlimited) showMutiMode.value = false;
});
</script>

<style scoped>
:deep(.all-tabs .van-tabs__content) {
  overflow: auto;
}

:deep(.van-tabs__nav .van-tab__text) {
  text-overflow: unset;
}
</style>
